import axios from "axios";
import { ApiUrl } from "../utils/modules";
// import { header } from "../utils/modules";

class AuthServices {
  login(credentials) {
    return axios.post(`${ApiUrl}auth/login`, credentials);
  }

  //   register(credentials) {
  //     return axios.post(`${ApiUrl}auth/register`, credentials);
  //   }

  checkToken(token) {
    return axios.get(`${ApiUrl}auth/me`, { headers: { Authorization: `Bearer ${token}` } });
  }
  verifyOtp(data) {
    return axios.post(`${ApiUrl}auth/verify-otp`, data);
  }

  refreshToken(data) {
    return axios.post(`${ApiUrl}auth/refresh-token`, data);
  }

  logout() {
    return axios.post(`${ApiUrl}auth/logout`);
  }
  verifyCaptchaV3(token) {
    return axios.post(`${ApiUrl}auth/verify-captcha`, token);
  }

  forgotPassword(data) {
    return axios.post(`${ApiUrl}auth/forgot-password`, data);
  }

  resetPassword(data) {
    return axios.post(`${ApiUrl}auth/reset-password`, data);
  }

}

export default new AuthServices();
